export const truncate = (text: string, length: number) => {
  return text.length > length ? text.substring(0, length) + '...' : text
}
export const truncateWords = (text: string, length: number) => {
  return text.split(' ').slice(0, length).join(' ') + '...'
}
export const getFirstParagraph = (text: string) => {
  return text.split('\n')[0]
}
export const basicSanitizeHtml = (html: string): string => {
  const stripped = html.replace(/<\/?[^>]+(>|$)/g, '');

  const htmlEntities: Record<string, string> = {
    '&nbsp;': ' ',
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
    '&quot;': '"',
    '&#39;': "'",
  };

  return stripped.replace(/&(#(?:x[0-9a-f]+|\d+)|[a-z]+);/gi, (entity, code) => {
    const lowerEntity = entity.toLowerCase();
    if (lowerEntity in htmlEntities) {
      return htmlEntities[lowerEntity];
    }
    if (code[0] === '#') {
      let num = 0;
      if (code[1].toLowerCase() === 'x') {
        num = parseInt(code.slice(2), 16);
      } else {
        num = parseInt(code.slice(1), 10);
      }
      if (!isNaN(num)) {
        return String.fromCharCode(num);
      }
    }
    return entity;
  });
};

export const removeTrailingSlash = (url: string): string => {
  return url.replace(/\/+$/, '')
}

export const removeLeadingSlash = (url: string): string => {
  return url.replace(/^\/+/, '')  
} 

export function sanitize(input: string): string {
  if (typeof document === 'undefined') return input;
  const el = document.createElement('div');
  el.innerText = input;
  return el.innerHTML;
}

export const removePTags = (html: string): string => {
  if (!html) return html;

  return html.replace(/<\/?p\b[^>]*>/gi, '');
};